import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-title">
        <p>CONTACT</p>
      </div>
      <div className="footer-content">
        <p>
          <a
            href="https://www.instagram.com/giovannaohl/"
            target="_blank"
            rel="noreferrer"
          >
            @giovannaohl
          </a>
        </p>
        <p>
          <a
            href="https://www.linkedin.com/in/giovannaohlfedel/"
            target="_blank"
            rel="noreferrer"
          >
            linkedin/giovannaohl
          </a>
        </p>
        <p>
          <a href="mailto:giovannaohl@gmail.com">giovannaohl@gmail.com</a>
        </p>
        <p>
          <a
            href="//api.whatsapp.com/send?phone=5511960333550&text=hello!"
            target="_blank"
            rel="noreferrer"
            className="link"
          >
            +55 11 96033-3550
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
